import { generateId } from '@freelancer/datastore/testing';
import { TimeUnitApi } from 'api-typings/common/common';
import { SubscriptionStatusApi } from 'api-typings/memberships/memberships_types';
import { User } from '../users';
import { MembershipSubscriptionHistory } from './membership-subscription-history.model';

export interface GenerateMembershipSubscriptionHistoryOptions {
  readonly user: User;
  readonly packageId: number;
  readonly contractQuantity?: number;
  readonly isTrial?: boolean;
  readonly durationType?: TimeUnitApi;
}

export function generateMembershipSubscriptionHistoryObjects({
  user,
  packageId,
  contractQuantity,
  isTrial = false,
  durationType = TimeUnitApi.DAY,
}: GenerateMembershipSubscriptionHistoryOptions): readonly MembershipSubscriptionHistory[] {
  return [
    {
      id: generateId(),
      packageId,
      timeStarted: Date.now(),
      timeEndedExpected: Date.now() + 86400000, // 1 day
      priceId: 1,
      periodId: 1,
      status: SubscriptionStatusApi.ACTIVE,
      userId: user.id,
      quantity: 1,
      lastPaidTransactionId: 1,
      isTrial,
      duration: {
        id: 1,
        type: durationType,
        cycle: 1,
      },
      price: {
        id: 1,
        packageId,
        durationId: 1,
        durationType,
        durationCycle: 1,
        amount: 1,
        currencyId: 1,
        timeValidStart: Date.now(),
        contractQuantity,
      },
      period: {
        id: 1,
        packageId,
        userId: user.id,
        timeStarted: Date.now(),
      },
    },
  ];
}
